import api from '@/api'

const store = {
  state: {
    dataModifierPrice: [],
    pagingModifierPrice: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingModifierPrice: {
      byField: '',
      isDesc: false
    },
    filteringModifierPrice: {
      modifierItemCode: null,
      modifierGroupCode: null,
      priceType: null,
      price: null
    }
  },

  mutations: {
    SET_MODIFIERPRICE: (state, payload) => {
      state.dataModifierPrice = payload
    },
    SET_PAGING_PAGE_MODIFIERPRICE: (state, payload) => {
      state.pagingModifierPrice.page = payload
    },
    SET_PAGING_TOTAL_MODIFIERPRICE: (state, payload) => {
      state.pagingModifierPrice.total = payload
    },
    SET_SORTING_MODIFIERPRICE: (state, payload) => {
      state.sortingModifierPrice = payload
    },
    SET_FILTERING_MODIFIERPRICE: (state, payload) => {
      state.filteringModifierPrice = payload
    }
  },

  getters: {
    SortingModifierPrice: state => state.sortingModifierPrice,
    FilteringModifierPrice: state => state.filteringModifierPrice,
    PagingModifierPrice: state => state.pagingModifierPrice,
    GetAllModifierPrice: state => state.dataModifierPrice,
    GetOneModifierPrice: state => id =>
      state.dataModifierPrice.find(
        dataModifierPrice => dataModifierPrice.id === id
      )
  },

  actions: {
    async UpdateSortingModifierPrice({ commit, dispatch }, payload) {
      commit('SET_SORTING_MODIFIERPRICE', {
        byField: payload.byField,
        isDesc: payload.isDesc
      })
      dispatch('GetAllModifierPrice')
    },

    async UpdateFilteringModifierPrice({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const emptyFilter = {
          cond: null,
          code: null,
          description: null
        }
        commit('SET_FILTERING_MODIFIERPRICE', emptyFilter)
      }
      commit('SET_PAGING_PAGE_MODIFIERPRICE', 1)
      dispatch('GetAllModifierPrice')
    },

    async GetAllModifierPrice({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllModifierPrice(
          state.pagingModifierPrice,
          state.sortingModifierPrice,
          state.filteringModifierPrice
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_MODIFIERPRICE', result.headers['data-length'])
        commit('SET_MODIFIERPRICE', result.data.data)
        return result.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateModifierPrice({ dispatch }, payload) {
      try {
        const { data } = await api.CreateModifierPrice(payload)
        dispatch('GetAllModifierPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateModifierPrice({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateModifierPrice(payload.id, payload)
        dispatch('GetAllModifierPrice')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteModifierPrice({ dispatch }, id) {
      try {
        const { data } = await api.DeleteModifierPrice(id)
        dispatch('GetAllModifierPrice')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
